import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  NumberPicker,
  Calendar,
  List,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'antd/dist/antd.css';
import { Modal } from 'antd'; //dialog UI

import axios from 'axios';
import ezconImg from '../../../../../public/ezcon.png';

const Option = Select.Option;
const { Item } = Form;
const currentDate = moment();
const localeData = currentDate.clone().localeData();
const monthLocale = localeData.monthsShort();
const CleanFrontDeskList = (props) => {
  //residentAccountNumbers 戶號Table
  const residentAccountNumbers = client.service('residentAccountNumbers');
  //clean 公告Table
  const clean = client.service('clean');
  const calendarResult = client.service('calendarResult');
  const [cleanArr, setCleanArr] = useState([]);
  const [cleanCurrentArr, setCleanCurrentArr] = useState([]);
  const [addCleanDialog, setAddCleanDialog] = useState(false);
  const [editCleanDialog, setEditCleanDialog] = useState(false);
  const [editCleanIndex, setEditCleanIndex] = useState('');
  const [titleText, setTitleText] = useState('');
  const [contentText, setContentText] = useState('');
  const [category, setCategory] = useState('');
  const [cleanTime, setCleanTime] = useState('');
  const [count, setCount] = useState(0);
  const [range, setRange] = useState('');
  const [previewDialog, setPreviewDialog] = useState(false);
  const [status, setStatus] = useState(false);
  const [showDate, setShowDate] = useState(moment().add(0, 'days'));
  //查詢 clean
  function funFind(para) {
    return new Promise((resolve, reject) => {
      try {
        clean.find({ query: para }).then((result) => {
          resolve(result && result.data ? addCloneCalendar(result.data) : []);
          // resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //查詢 calendarResult
  function calendarResultFind(para) {
    return new Promise((resolve, reject) => {
      try {
        calendarResult.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function addCloneCalendar(resD) {
    let OutArr = [];
    resD.forEach((e) => {
      e.cleanTime.forEach((ee) => {
        const outObj = {
          cleanTime: ee,
          name: e.name,
          contentText: e.titleText,
          id: e._id,
        };
        OutArr.push(outObj);
      });
    });
    return OutArr;
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  //刷新頁面
  function serverDataUpdate() {
    funFind({}).then((result) => {
      calendarResultFind({}).then((result2) => {
        setCleanArr(result.sort(ordersort).concat(result2));
      });
    });
  }

  useEffect(() => {
    serverDataUpdate();
  }, []);

  function dateCellRender(date) {
    const dateNum = date.date();
    let str = '';
    // let str2 = ''
    for (let i = 0; i < cleanArr.length; i++) {
      let cleanTime = cleanArr[i]['cleanTime'];
      let formatTime = moment(cleanTime).format('YYYYMMDD');
      if (
        formatTime.substr(4, 2) == date.month() + 1 &&
        formatTime.substr(6, 2) == dateNum
      ) {
        str += `工作項目:${cleanArr[i]['name']}
        注意事項:${cleanArr[i]['contentText']}
        `;
      }
    }
    if (str) {
      const formatStr = str.split('\n').map((value, index) => {
        return <div key={index}>{value}</div>;
      });
      return (
        <>
          <div className={styles.calendarMonthBox}>
            <div className={styles.calendarMonthText}>{dateNum}</div>
            <div>{formatStr}</div>
          </div>
        </>
      );
    }
    return dateNum;
  }

  function monthCellRender(date) {
    let str = '';
    for (let i = 0; i < cleanArr.length; i++) {
      let cleanTime = cleanArr[i]['cleanTime'];
      let formatTime = moment(cleanTime).format('YYYYMMDD');
      if (formatTime.substr(4, 2) == date.month() + 1) {
        str += `標題:${cleanArr[i]['name']}
        注意事項:${cleanArr[i]['contentText']}
        `;
      }
    }
    if (str) {
      const formatStr = str.split('\n').map((value, index) => {
        return <div key={index}>{value}</div>;
      });
      return (
        <>
          <div>{monthLocale[date.month()]}</div>
          <div className={styles.calendarYearBox}>
            <div>{formatStr}</div>
          </div>
        </>
      );
    }
    return monthLocale[date.month()];
  }

  function monthCellRender2(date) {
    //render年
    const dateNum = date.date();
    const thisStartDate = new Date(
      `${date.year()}/${date.month() + 1}/1`
    ).getTime(); //月初time
    const thisEndDate = new Date(date.year(), date.month() + 1, 0).getTime(); //月底time
    let renderArr = [];
    let idArrs = [];
    let eventList = cleanArr.filter(
      (i) => i.cleanTime >= thisStartDate && i.cleanTime <= thisEndDate
    ); //找到當月所有任務(有重複)
    eventList.forEach((e) => {
      //過濾掉相同id任務(只show一次)
      if (!idArrs.includes(e.id)) {
        idArrs.push(e.id);
        renderArr.push(e);
      }
    });
    const formatStr = renderArr.map((i, nb) => {
      return <div key={nb}>工作項目:{i.name}</div>;
    });

    return (
      <>
        <div>{monthLocale[date.month()]}</div>
        <div className={styles.calendarYearBox}>
          <div>{formatStr}</div>
        </div>
      </>
    );
  }

  function dateCellRender2(date) {
    //渲染測試
    const dateNum = date.date();
    const thisCalendarDate = new Date(
      `${date.year()}/${date.month() + 1}/${dateNum}`
    ).getTime(); //當日time
    let eventList = cleanArr.filter((i) => i.cleanTime == thisCalendarDate);

    const formatStr = eventList.map((i, nb) => {
      return (
        <div key={nb}>
          <div>工作項目:{i.name}</div>
          {/* <div>注意事項:{i.contentText}</div> */}
        </div>
      );
    });
    return (
      <>
        <div className={styles.calendarMonthBox}>
          <div className={styles.calendarMonthText}>{dateNum}</div>
          <div>{formatStr}</div>
        </div>
      </>
    );
  }

  return (
    <>
      <Modal
        closable={false}
        cancelText
        mask={false}
        className={styles.dialog}
        visible={previewDialog}
        onOk={() => {
          setPreviewDialog(false);
        }}
        onCancel={() => {
          setPreviewDialog(false);
        }}
        okText="關閉"
      >
        <Form>
          <h1>清潔項目</h1>
          {cleanCurrentArr.map((list, index) => {
            return (
              <div key={index} className={styles.listContainer}>
                {list.cleanTime <=
                new Date(new Date().toDateString()).getTime() ? (
                  // 今天||今天之前
                  <div>
                    <Item label="清潔日期">
                      <p>{new Date(list.cleanTime).toLocaleDateString()}</p>
                    </Item>
                    <Item label="清潔項目">
                      <p>{list.name}</p>
                    </Item>
                    <Item label="注意事項">
                      <p>{list.contentText}</p>
                    </Item>
                    {/* <Item label="工作週期">
                      <p>{list.cycle}</p>
                    </Item> */}
                    <Item label="工作進度">
                      <p>{list.status == true ? '完成' : '未完成'}</p>
                    </Item>
                    <Item label="驗收人員簽章">
                      <p>{list.signature}</p>
                    </Item>
                  </div>
                ) : (
                  // >今天
                  <div>
                    <Item label="清潔日期">
                      <p>{new Date(list.cleanTime).toLocaleDateString()}</p>
                    </Item>
                    <Item label="清潔項目">
                      <p>{list.name}</p>
                    </Item>
                    <Item label="注意事項">
                      <p>{list.contentText}</p>
                    </Item>
                    <Item label="工作週期">
                      <p>{list.cycle}</p>
                    </Item>
                  </div>
                )}
              </div>
            );
          })}
        </Form>
      </Modal>
      {/* 日曆ＵＩ */}

      <Calendar
        // mode
        onSelect={(value) => {
          // console.log(new Date(value))

          if (
            new Date(value).getTime() >
            new Date(new Date().toDateString()).getTime()
          ) {
            //點擊的日期>今天
            clean
              .find({
                query: {
                  //cleanTime: new Date(value).getTime(),
                  cleanTime: {
                    $in: [new Date(value).getTime()],
                  },
                },
              })
              .then((res) => {
                console.log('==clean find success:', res.data);
                setShowDate(moment(new Date(value).getTime()).add(0, 'days'));
                res.data.map((i) => (i.cleanTime = new Date(value).getTime())); //改成帶搜尋日期
                setCleanCurrentArr(res.data);
                setPreviewDialog(true);
                Message.success('找尋資料成功');
              })
              .catch((error) => {
                console.log('==clean find fail:', error);
                Message.success('找尋資料失敗');
              });
          } else {
            //點擊日期<=今天
            calendarResult
              .find({
                query: {
                  cleanTime: new Date(value).getTime(),
                },
              })
              .then((res) => {
                console.log('==clean find success-2:', res.data);
                setShowDate(moment(new Date(value).getTime()).add(0, 'days'));
                //res.data.map((i)=>i.cleanTime=new Date(value).getTime());//改成帶搜尋日期
                setCleanCurrentArr(res.data);
                setPreviewDialog(true);
                Message.success('找尋資料成功');
              })
              .catch((error) => {
                console.log('==clean find fail-2:', error);
                Message.success('找尋資料失敗');
              });
          }
        }}
        dateCellRender={dateCellRender2}
        monthCellRender={monthCellRender2}
        yearRange={[2021, new Date().getFullYear() + 1]}
        value={showDate}
      />
    </>
  );
};

export default CleanFrontDeskList;
